<template>
  <div class="nova-senha-link-expirado">
    <h2>LINK EXPIRADO</h2>
    <div>
      <div class="text-center">
        <router-link class='link' :to="{name: 'login'}">Já tenho uma conta</router-link>
      </div>
      <div class="">
        <img src="https://i.imgur.com/hu80UGU.png" class="link-expirado__image"/>
      </div>
    </div>
  </div>
</template>

<script>
import VuesticPageNotFoundSadWallpaper from '../../pages/404-pages/VuesticPageNotFoundSadWallpaper.vue'

export default {
  name: 'nova-senha',
  components: {
    VuesticPageNotFoundSadWallpaper
  },
}
</script>

<style lang="scss">
  .nova-senha-link-expirado {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
    }
    width: 22.375rem;

    .down-container {
      margin-top: 2.6875rem;
    }
  }

  .link-expirado {
    &__image {
      width: 505px;
      height: 400px;
      position: absolute;
      padding: 20px 20px 0 20px;
      right: 160px;
      bottom: 0;
    }

    @include media-breakpoint-down(md) {
      &__image {
        width: 400px;
        height: 320px;
        right: -28px;
        overflow: hidden;
      }
    }

  }
</style>
